import { Input, Alert } from "@heroui/react";
import { LuInfo } from "react-icons/lu";
import { MapPicker } from "@/components/ui";

const AddressStep = ({ watch, setValue, register }) => {
    const addressData = watch("address");

    // Handle map location change
    const handleLocationChange = (location) => {
        if (!location) return;

        setValue("address.full_address", location.formattedAddress || "");
        setValue("address.village", location.village || "");
        setValue("address.district", location.district || "");
        setValue("address.city", location.city || "");
        setValue("address.province", location.province || "");
        setValue("address.postal_code", location.postalCode || "");
        setValue("address.lat", location.lat || null);
        setValue("address.lng", location.lng || null);
        setValue("address.google_map_url", location.googleMapUrl || "");
    };

    return (
        <div className="flex flex-col gap-4">
            <Alert
                color="primary"
                variant="flat"
                icon={
                    <div className="flex items-center justify-center">
                        <LuInfo size={18} className="mx-auto" />
                    </div>
                }
                classNames={{
                    description: "text-xs",
                }}
                title="Pilih lokasi pada peta"
                description="Klik pada peta atau gunakan pencarian untuk menentukan lokasi. Data alamat akan terisi otomatis."
            />

            {/* Map Picker */}
            <MapPicker
                value={{
                    lat: addressData?.lat,
                    lng: addressData?.lng,
                    formattedAddress: addressData?.full_address,
                }}
                onChange={handleLocationChange}
            />

            {/* Address Fields - Controlled inputs to reflect setValue changes */}
            <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2">
                {/* Alamat Lengkap - Full Width */}
                <div className="md:col-span-2">
                    <Input
                        label="Alamat Lengkap"
                        placeholder="Alamat lengkap"
                        variant="bordered"
                        value={addressData?.full_address || ""}
                        onValueChange={(val) =>
                            setValue("address.full_address", val)
                        }
                    />
                </div>

                {/* RT (1/4) + RW (1/4) + Kelurahan (1/2) */}
                <div className="grid grid-cols-4 gap-4 md:col-span-2">
                    <Input
                        {...register("address.neighborhood_unit")}
                        label="RT"
                        placeholder="Contoh: 001"
                        variant="bordered"
                        size="sm"
                    />
                    <Input
                        {...register("address.sub_neighborhood_unit")}
                        label="RW"
                        placeholder="Contoh: 002"
                        variant="bordered"
                        size="sm"
                    />
                    <div className="col-span-2">
                        <Input
                            label="Kelurahan"
                            placeholder="Kelurahan"
                            variant="bordered"
                            size="sm"
                            value={addressData?.village || ""}
                            onValueChange={(val) =>
                                setValue("address.village", val)
                            }
                        />
                    </div>
                </div>

                {/* Kecamatan + Kota */}
                <Input
                    label="Kecamatan"
                    placeholder="Kecamatan"
                    variant="bordered"
                    value={addressData?.district || ""}
                    onValueChange={(val) => setValue("address.district", val)}
                />

                <Input
                    label="Kota/Kabupaten"
                    placeholder="Kota/Kabupaten"
                    variant="bordered"
                    value={addressData?.city || ""}
                    onValueChange={(val) => setValue("address.city", val)}
                />

                {/* Provinsi + Kode Pos */}
                <Input
                    label="Provinsi"
                    placeholder="Provinsi"
                    variant="bordered"
                    value={addressData?.province || ""}
                    onValueChange={(val) => setValue("address.province", val)}
                />

                <Input
                    label="Kode Pos"
                    placeholder="Kode Pos"
                    variant="bordered"
                    value={addressData?.postal_code || ""}
                    onValueChange={(val) =>
                        setValue("address.postal_code", val)
                    }
                />
            </div>
        </div>
    );
};

export default AddressStep;
